import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/site/Reveal";
import { usePageMeta } from "@/lib/usePageMeta";
import { CASE_STUDIES } from "@/content/site";

export default function CaseStudies() {
  usePageMeta(
    "Power Tool Repair Case Studies | NE Tool Repair Newcastle",
    "Real Milwaukee power tool repairs from NE Tool Repair in Newcastle and the North East, with step-by-step photos and before-and-after results.",
    "/case-studies"
  );
  return (
    <div data-testid="case-studies-page">
      <section className="relative border-b border-[var(--line)] overflow-hidden">
        <div className="absolute inset-0 grid-lines [mask-image:linear-gradient(to_bottom,black,transparent)]" aria-hidden />
        <div className="relative mx-auto max-w-[1400px] px-5 md:px-10 pt-16 md:pt-24 pb-14 md:pb-20 grid lg:grid-cols-12 gap-10 items-end">
          <Reveal className="lg:col-span-8">
            <Eyebrow>From the bench</Eyebrow>
            <h1 className="mt-6 font-display font-black uppercase text-6xl sm:text-7xl lg:text-[7.5rem] leading-[0.86]">Repair<br /><span className="text-[var(--red)]">case studies</span></h1>
          </Reveal>
          <Reveal className="lg:col-span-4" delay={0.1}>
            <p className="text-base text-[var(--grey)] leading-relaxed">Real repairs, photographed step by step on the bench, from the damage to the finished tool.</p>
          </Reveal>
        </div>
      </section>
      <section className="py-14 md:py-20 border-b border-[var(--line)]">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid md:grid-cols-2 gap-6">
          {CASE_STUDIES.map((c) => (
            <Reveal key={c.slug}>
              <Link to={`/case-studies/${c.slug}`} className="group block" data-testid={`case-card-${c.number}`}>
                <div className="aspect-square overflow-hidden chamfer border border-[var(--line)]">
                  <img src={c.cover?.src} alt={c.cover?.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
                </div>
                <div className="mt-5 flex items-start justify-between gap-6">
                  <div>
                    <p className="font-mono text-xs uppercase tracking-[0.18em] text-[var(--red)]">Case study #{c.number} · {c.tool}</p>
                    <h2 className="mt-2 font-display font-black uppercase text-4xl md:text-5xl leading-[0.95]">{c.title}</h2>
                    <ul className="mt-4 flex flex-wrap gap-2">
                      {c.process.map((p) => <li key={p} className="border border-[var(--line)] px-3 py-1.5 font-mono text-xs uppercase tracking-[0.16em] text-[var(--grey)]">{p}</li>)}
                    </ul>
                  </div>
                  <span className="h-12 w-12 shrink-0 inline-flex items-center justify-center bg-[var(--red)] transition-transform duration-300 group-hover:rotate-45" aria-hidden><ArrowUpRight className="h-5 w-5" /></span>
                </div>
              </Link>
            </Reveal>
          ))}
          <div className="metal chamfer border border-dashed border-[var(--line)] aspect-square md:aspect-auto flex flex-col items-center justify-center text-center p-8" data-testid="case-more-soon">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[var(--mute)]">Case study #002</p>
            <p className="mt-3 font-display font-extrabold uppercase text-3xl text-[var(--grey)]">More repairs coming soon</p>
          </div>
        </div>
      </section>
    </div>
  );
}
